import axios from "axios";

const API_URL = "http://localhost:8080/api/auth/";
// const API_URL = process.env.REACT_APP_BASE_URL || "http://localhost:3001/api/auth/"; 


class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "signin", {
        username,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password, DOB, phone, address, firstName, lastName) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password,
      DOB,
      phone,
      address,
      firstName,
      lastName,
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }
}

const authService = new AuthService();
export default authService;
